// extracted by mini-css-extract-plugin
module.exports = {"picker":"DatePicker_picker__2XIU6","hideCalendarIcon":"DatePicker_hideCalendarIcon__2qrxU"};